import { z } from "zod/v4";
const INITIAL_VERSION = 1;
const VersionSchema = z.coerce.number().int().nonnegative().brand();
export const Version = {
    schema: VersionSchema,
    initial() {
        return Version.schema.parse(INITIAL_VERSION);
    },
    of(args) {
        return Version.schema.parse(args);
    },
};
//# sourceMappingURL=version.js.map